export const ADMIN_STORE_VIEW_SESSION_KEY = 'optimizedInsiderAdminStoreView';
export const DEFAULT_ADMIN_RETURN_PATH = '/admin';

export function normalizeAdminReturnPath(pathname) {
  if (typeof pathname !== 'string') return DEFAULT_ADMIN_RETURN_PATH;
  const trimmed = pathname.trim();
  if (trimmed === '/admin' || trimmed.startsWith('/admin/')) return trimmed;
  return DEFAULT_ADMIN_RETURN_PATH;
}

export function parseAdminStoreViewState(rawValue) {
  if (!rawValue) {
    return { enabled: false, returnPath: DEFAULT_ADMIN_RETURN_PATH };
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (parsed?.enabled !== true) {
      return { enabled: false, returnPath: DEFAULT_ADMIN_RETURN_PATH };
    }
    return {
      enabled: true,
      returnPath: normalizeAdminReturnPath(parsed.returnPath),
    };
  } catch {
    return { enabled: false, returnPath: DEFAULT_ADMIN_RETURN_PATH };
  }
}

export function readAdminStoreViewState(storage = globalThis?.sessionStorage) {
  try {
    return parseAdminStoreViewState(storage?.getItem(ADMIN_STORE_VIEW_SESSION_KEY));
  } catch {
    return { enabled: false, returnPath: DEFAULT_ADMIN_RETURN_PATH };
  }
}

export function writeAdminStoreViewState(state, storage = globalThis?.sessionStorage) {
  const safeState = {
    enabled: state?.enabled === true,
    returnPath: normalizeAdminReturnPath(state?.returnPath),
  };
  try {
    storage?.setItem(ADMIN_STORE_VIEW_SESSION_KEY, JSON.stringify(safeState));
  } catch {
    // Store view remains usable in memory when session storage is unavailable.
  }
  return safeState;
}

export function clearAdminStoreViewState(storage = globalThis?.sessionStorage) {
  try {
    storage?.removeItem(ADMIN_STORE_VIEW_SESSION_KEY);
  } catch {
    // Clearing the in-memory context still exits store view.
  }
  return { enabled: false, returnPath: DEFAULT_ADMIN_RETURN_PATH };
}
